import {
  CrItemsSelect,
  Props as CrItemsSelectProps,
} from '@/components/CrItemsSelect';
import { PaymentRequestForm } from '@/features/InvoiceReport/Edit/type';
import { memo, useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { CellProps } from './type';

type Props<TFieldValues extends PaymentRequestForm> =
  CrItemsSelectProps<TFieldValues> & CellProps;

const InnerCrItemsSelectCell = <TFieldValues extends PaymentRequestForm>({
  index,
  ...props
}: Props<TFieldValues>) => {
  const cacheKey = useMemo(() => ['row', 'cr_item', index], [index]);
  const { setValue } = useFormContext<PaymentRequestForm>();
  const setLabelField = useCallback(
    (labelFieldValue: string) => {
      setValue(`invoiceTransactions.${index}.crItemName`, labelFieldValue);
    },
    [setValue, index]
  );

  return (
    <CrItemsSelect<TFieldValues>
      per={500}
      cacheQueryKey={cacheKey}
      {...props}
      setLabelField={setLabelField}
    />
  );
};
InnerCrItemsSelectCell.displayName = 'InnerCrSubItemsSelectCell';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const CrItemsSelectCell = memo(
  InnerCrItemsSelectCell
) as typeof InnerCrItemsSelectCell;
CrItemsSelectCell.displayName = 'CrSubItemsCell';
